export default "__VITE_ASSET__BJZfEhvz__"